import { createFileRoute } from "@tanstack/react-router";
import LoadingPage from "lib/components/layout/LoadingPage";
import withAuthentication from "../../components/withAuthentication";

/**
 * Showroom preview of an in-progress Studio doc. Fetches the doc by
 * `studioDocId` and injects it as fake plan data so the normal showroom
 * viewer can render a design that isn't yet a published plan.
 */
function ShowroomStudio() {
  return <LoadingPage pageTitle="Showroom" />;
}

export const Route = createFileRoute("/showroom/studio")({
  component: withAuthentication(ShowroomStudio, {
    features: ["showroomUnification"],
    products: ["showroom"],
  }),
});
